"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6577],{

/***/ 97537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var LayoutContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext();
/* harmony default export */ __webpack_exports__["Z"] = (LayoutContext);

/***/ }),

/***/ 36577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Zone; }
/* harmony export */ });
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88674);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82772);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Layout_LayoutContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97537);
/* harmony import */ var _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(24036);
/* harmony import */ var _adapters_helpers_Block__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(40483);
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1216);
/* harmony import */ var _adapters_helpers_Loader__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47322);
/* harmony import */ var _adapters_helpers_Utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8996);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85893);













var Image = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(function () {
  return __webpack_require__.e(/* import() */ 8084).then(__webpack_require__.bind(__webpack_require__, 48084));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(48084)];
    }
  }
});
function Zone(props) {
  var block = new _adapters_helpers_Block__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z(props);
  var extraAttributes = props.extraAttributes || {};
  var zoneRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)();
  var ariaHidden = false;
  var className = getClassNames(block);
  var role = block.getFieldValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_6__/* .ZoneConstants.role */ .j0.role);
  var id = block.getFieldValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_6__/* .ZoneConstants.id */ .j0.id);
  var ariaLabel = block.getFieldValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_6__/* .ZoneConstants.ariaLabel */ .j0.ariaLabel);
  var backgroundImage = block.getFieldValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_6__/* .ZoneConstants.backgroundImage */ .j0.backgroundImage);
  var children = block.renderChildBlocks({
    extraAttributes: extraAttributes
  }, props.onClickCallback, props.customEvent);
  var layoutContext = (0,react__WEBPACK_IMPORTED_MODULE_3__.useContext)(_Layout_LayoutContext__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z);

  var _ref = layoutContext ? layoutContext : {
    isContestVisible: false
  },
      isContestVisible = _ref.isContestVisible;

  var hideZonesIfContestVisible = function hideZonesIfContestVisible() {
    if (block.getFieldValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_6__/* .ZoneConstants.classNames */ .j0.classNames) === _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_6__/* .ZoneConstants.zoneSpotlightSliderBodyClassname */ .j0.zoneSpotlightSliderBodyClassname && isContestVisible) {
      className += ' zoneHidden';
    }

    if (block.getFieldValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_6__/* .ZoneConstants.classNames */ .j0.classNames) === _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_6__/* .ZoneConstants.zoneSpotlightContestClassname */ .j0.zoneSpotlightContestClassname && !isContestVisible) {
      className += ' zoneHidden';
    }

    ariaHidden = className.indexOf('zoneHidden') !== -1;
  };

  hideZonesIfContestVisible();
  (0,react__WEBPACK_IMPORTED_MODULE_3__.useLayoutEffect)(function () {
    setTimeout(function () {
      (0,_adapters_helpers_Utils__WEBPACK_IMPORTED_MODULE_10__/* .enableDisableFocusOnElements */ .MX)(zoneRef.current, !ariaHidden);
    }, 1);
  });
  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function () {
    className = getClassNames(block);
    hideZonesIfContestVisible();
    (0,_adapters_helpers_Utils__WEBPACK_IMPORTED_MODULE_10__/* .enableDisableFocusOnElements */ .MX)(zoneRef.current, !ariaHidden);
  }, [isContestVisible]);
  return backgroundImage ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react__WEBPACK_IMPORTED_MODULE_3__.Suspense, {
    fallback: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_adapters_helpers_Loader__WEBPACK_IMPORTED_MODULE_9__["default"], {}),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
      ref: zoneRef,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(Image, {
        image: backgroundImage,
        zoneClassName: className,
        ariaHidden: ariaHidden,
        children: children
      })
    })
  }) : id === 'footer' ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_lazyload__WEBPACK_IMPORTED_MODULE_8__["default"], {
    offset: 10,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.Fragment, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
        ref: zoneRef,
        className: className,
        id: id ? id : role === 'main' ? role : null,
        "aria-label": ariaLabel,
        "aria-hidden": ariaHidden,
        role: role,
        children: children
      })
    })
  }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
    ref: zoneRef,
    className: className,
    id: id ? id : role === 'main' ? role : null,
    "aria-label": ariaLabel,
    "aria-hidden": ariaHidden,
    role: role,
    children: children
  });
}

function getClassNames(block) {
  var classNames = _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_6__/* .ZoneConstants.zone */ .j0.zone;
  var zoneClassNames = block.getFieldValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_6__/* .ZoneConstants.classNames */ .j0.classNames);

  if (zoneClassNames) {
    classNames += zoneClassNames;
  }

  return classNames;
}

/***/ })

}]);